const url = "http://localhost:8000/public/uploads/profile_pictures/";
export default url;
